module.exports = __webpack_public_path__ + "img/footImg.c955b6a7.png";